module.exports = __webpack_public_path__ + "static/media/back.a9e2fa3e.svg";